import { render, staticRenderFns } from "./JVxeFileCell.vue?vue&type=template&id=6618940d&scoped=true"
import script from "./JVxeFileCell.vue?vue&type=script&lang=js"
export * from "./JVxeFileCell.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6618940d",
  null
  
)

export default component.exports